module.exports = __webpack_public_path__ + "img/把立.SLDPRT.a61ee9a9.jpg";